import { Component, computed, input } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-filters-item',
  styleUrl: './item.css',
  templateUrl: './item.html',
})
export class FiltersItem {
  public readonly label = input('');
  public readonly labelFirst = input(true);

  protected readonly containerClass = computed(() => {
    if (!this.labelFirst()) {
      return 'flex justify-between gap-4 flex-row-reverse';
    }

    return 'flex justify-between gap-4';
  });
}
